import { createSlice } from "@reduxjs/toolkit";
import {
  addParent,
  getAvailableLanguages,
  getLanguageSettings,
  getSettings,
  getPaymentStatus
} from "./actions";

const initialState = {
  settings: null,
  loading: false,
  error: "",
  parentWallet: null, // Added for storing linked parent wallet
  paymentStatus: null,
  paymentStatusLoading: false,
  language: {}, // stores current selected language translations
  languageList: [], // stores all available languages
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSettings.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(getSettings.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addParent.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(addParent.fulfilled, (state, action) => {
        state.loading = false;
        state.parentWallet = action.payload; // Storing in correct place
      })
      .addCase(addParent.rejected, (state) => {
        state.loading = false;
      })

      // 🔹 getLanguageSettings
      .addCase(getLanguageSettings.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getLanguageSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.language = { ...action.payload };
      })
      .addCase(getLanguageSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch language settings";
      })

      // 🔹 getAvailableLanguages
      .addCase(getAvailableLanguages.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAvailableLanguages.fulfilled, (state, action) => {
        state.loading = false;
        state.languageList = action.payload;
      })
      .addCase(getAvailableLanguages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch language list";
      })


      .addCase(getPaymentStatus.pending, (state) => {
        state.paymentStatusLoading = true;
        state.error = "";
      })
      .addCase(getPaymentStatus.fulfilled, (state, action) => {
        state.paymentStatusLoading = false;
        state.paymentStatus = action.payload;
      })
      .addCase(getPaymentStatus.rejected, (state) => {
        state.paymentStatusLoading = false;
      });
  },
});

export default settingsSlice.reducer;
